import { useEffect, useState, useRef } from 'react'
import { useRouter } from 'next/router'
import styles from './index.module.css'
import { forgotpassword } from '../../../../../common/lib/forgotpassword'
import { login, resendOtp, userLogin, userVerify } from '../../../../../common/lib/login'
import { contactus } from '../../../../../common/lib/signup'
import ModalPopupComponent from '../../../../../common/components/ModalPopupComponent/ModalPopupComponent'
import modalCss from '../../../../../common/components/ModalPopupComponent/index.module.css'
import CountryDropdownComp from '@/components/CountryDropdown/index'
import getCountriesList from '../../../../../common/lib/getCountriesList'
import Countrystyles from '../../../../../common/components/CountryDropdown/theme9/index.module.css'
import { changepassword } from '../../../../../common/lib/changepassword'
import InvalidPassword from './InvalidPassword'
import { tokenExpiry } from '../../../../../common/lib/tokenExpiry'
import { getCityByCountry } from '../../../../lib/myProfile'
import { encryptData } from '../../../../../common/lib/crypto/crypto'
import OTPInput from '@/components/otpInput'
import { VmsToolTip } from '@/components/vms-components/ToolTip/index'
import CaptchaComponent from '../../../../../common/components/captchaComp/index'
import {
  allowedCharactersRegex,
  spaceRestrict,
  passRestrict,
  isdCodeReg,
  alphanumericSpecialChars,
  emailReg,
  alphabetNameChars,
  phoneNoReg,
  aplhaNumericDash,
} from '../../../../../common/lib/utils/regex_cheat_sheet'
import { VmsInputText } from '@/components/vms-components/InputText/index'
import { VmsButton } from '@/components/vms-components/button/index'
import { VmsAutocompleteDropdown } from '@/components/vms-components/AutocompleteDropdown/index'
import { VmsMobileInputText } from '@/components/vms-components/MobileInputText/index'
import cf from '../../../../../common/lib/utils/common'

const errorsList = {
  firstName: {
    ERFN101: 'Please enter first name',
  },
  lastName: {
    ERLN101: 'Please enter last name',
  },
  companyName: {
    ERCN101: 'Please enter company name',
  },
  countryCode: {
    ERCC101: 'Please select the country code',
  },
  nationality: {
    ERNT101: 'Please select nationality',
  },
  city: {
    ERCT101: 'Please select city',
  },
  orgName: {
    ERORG101: 'Please select organisation type',
  },
  isdCode: {
    ERISD101: 'Please enter ISD Code',
  },
  address: {
    ERAD101: 'Please select address',
  },
  pincode: {
    ERPN101: 'Please select pincode',
  },
  mobileNo: {
    ERMN101: 'Invalid mobile number',
    ERMN102: 'Please enter mobile number',
  },
  email: {
    ERE101: 'Please enter email address',
    ERE102: 'Please enter a valid email address',
  },
  password: {
    ERP101:
      'Password must be between 8-13 characters in length and must comprise of at least 1 lowercase alphabet (a-z), 1 uppercase alphabet (A-Z), 1 number (0-9) and 1 special character',
    ERP104: 'Please enter password',
    ERP105: 'Incorrect password. Try again',
  },
  confirmPassword: {
    ERP102: 'Please re-enter new password',
    ERP103: 'Passwords do not match',
  },
  OTP: {
    EROTP101: 'Please enter OTP',
    EROTP102: 'The OTP entered is incorrect. Please try again',
    EROTP103: 'The OTP entered is incorrect. Please try again',
  },
  isTermsChecked: {
    ERTC101: 'Please accept the terms & conditions to proceed',
  },
}

let pwsEx = alphanumericSpecialChars

export default function Theme9(props) {
  const router = useRouter()
  const loginType = props?.pageInfo?.site?.login_type || 'only_password'
  const [type, setType] = useState('Signin')
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('')
  const [isOpen, setIsOpen] = useState(false)
  const [logincred, setLogincred] = useState({ email: '', password: '' })
  const [loginErrors, setLoginErrors] = useState({ email: '', password: '', otp: '' })
  const [onClickLoginLoader, setOnClickLoginLoader] = useState(false)
  const [isDisplay, setIsDisplay] = useState({
    email: true,
    password: false,
    otp: false,
    loginBtn: true,
    forgotPass: false,
  })
  const [forgotPasswordErr, setForgotPasswordErr] = useState('')
  const [loginErrMsg, setLoginErrMsg] = useState('')
  const [signupForm, setSignupForm] = useState({
    firstName: '',
    lastName: '',
    mobileNo: '',
    companyName: '',
    nationality: '',
    email: '',
    address: '',
    pincode: '',
    city: '',
    isdCode: '',
    orgName: '',
  })
  const [signupFormErr, setSignupFormErr] = useState({
    firstName: '',
    lastName: '',
    mobileNo: '',
    companyName: '',
    nationality: '',
    email: '',
    address: '',
    pincode: '',
    city: '',
    remark: '',
    isdCode: '',
    orgName: '',
  })
  const [originCountries, setOriginCountries] = useState([])
  const [selectedNationality, setSelectedNationality] = useState('')
  const [CountryCode, setCountryCode] = useState('')
  const [passwordObj, setPasswordObj] = useState({ newPassword: '', confirmPassword: '' })
  const [passwordObjErr, setPasswordObjErr] = useState({ newPassword: '', confirmPassword: '' })
  const [passwordUpdate, setPasswordUpdate] = useState(false)
  const [changePasswordAPIErr, setChangePasswordAPIErr] = useState('')
  const [resettokenExpiry, setResetTokenExpiry] = useState(false)
  const [cityList, setCityList] = useState([])
  const [selectedcity, setselectedCity] = useState('')
  const [CityCode, setCityCode] = useState('')
  const [state, setState] = useState({
    searchCountryText: '+91',
    demoForm: { countryCode: '' },
    demoFormErr: { countryCode: '' },
    selectedCountry: '',
  })
  const [showPassword, setShowPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showNewConfPassword, setShowNewConfPassword] = useState(false)
  const [fields, setFields] = useState({
    emailField: false,
    passwordField: false,
    otpField: false,
    loginWithOtpTxt: false,
  })
  const [showOtp, setShowOtp] = useState(false)
  const [loginWithOtp, setLoginWithOtp] = useState(true)
  const [otpLength, setOtpLength] = useState(0)
  const [exp_time, setExpTime] = useState()
  const [isOtpValid, setIsOtpValid] = useState(false)
  const imgLogo = props?.pageInfo?.data?.data?.signin?.upload_logo
    ? '/shared/api/media/' + props?.pageInfo?.data?.data?.signin?.upload_logo
    : '/images/curacao_logo.png'

  const [isForgotPassSent, setIsForgotPassSent] = useState(false)
  const [isContactUsConfirm, SetIsContactUsConfirm] = useState(false)
  const [isSendOtp, SetIsSendOtp] = useState(false)
  const OrganisationList = [
    'Construction',
    'Defense',
    'Educational',
    'Engineering',
    'Entertainment',
    'Financial',
    'Government',
    'Infrastructure',
    'Medical',
    'Pharmaceutical',
    'Private Sector',
    'Public Sector',
    'Technology',
    'Telecom',
    'Travel Agency',
  ]

  const [selectdropdown, setselectdropdown] = useState({
    selectedOrg: '',
    selectedCr: '',
    selectedIsd: '',
  })
  const [captchStates, setCaptchStates] = useState({
    captchErrorMsg: '',
    isCaptchaSelected: false,
    captchErrorMsg: '',
  })

  const newPassword = `Create a Strong and unique password with a mix of letters,numbers and symbols,such as "N4&VQ2!p"`
  const siteName = props?.pageInfo?.site?.site_name || ' '

  useEffect(() => {
    getLoginFields(loginType)
    getCountriesList().then((resp) => {
      let countryList = []
      if (resp?.data?.length > 0) {
        resp?.data.map((item) => {
          countryList.push({
            ...item,
            value: item.contry_name,
            isdCode: item.contry_isd,
            countryCode: item.contry_code,
            flag: item.contry_flag,
            countryFlag: item.contry_flag,
            countryName: item.contry_name,
          })
        })
      }
      setOriginCountries(countryList)
    })

    if (
      router.query &&
      router.query.resettoken &&
      router.query.resettoken !== '' &&
      router.query.resettoken !== null &&
      (router.query?.type?.trim() == 'B2B' || router.query?.type?.trim() == 'B2E')
    ) {
      setType('ResetPassword')
      setIsForgotPassSent(true)
      let response = {
        resettoken: router?.query?.resettoken,
        site_id: props?.home?.data?.site.id,
      }

      try {
        tokenExpiry(response).then((resp) => {
          if (resp && resp.data.status) {
            setResetTokenExpiry(false)
          } else {
            // setResetTokenExpiry(true);
            setType('resettokenExpiry')
          }
        })
      } catch (error) {
        console.error('Error occurred while processing token expiry:', error)
      }
    }
  }, [])

  useEffect(() => {
    if (isDisplay.otp) {
      onClickLoginBtn()
    }
  }, [isDisplay.otp])

  const onClickLoginWithOtp = () => {
    setFields({ ...fields, passwordField: loginWithOtp ? false : true })
    setLoginErrors({ ...loginErrors, email: '', password: '' })
    setLoginWithOtp(false)
    if (showOtp) {
      setIsDisplay({ email: false, password: false, otp: true, loginBtn: false })
    } else {
      setIsDisplay({ email: false, password: false, otp: true, loginBtn: true })
    }
  }

  const getLoginFields = (type) => {
    switch (type) {
      case 'only_password':
        setFields((prevState) => ({
          ...prevState,
          emailField: true,
          passwordField: true,
          otpField: false,
          loginWithOtpTxt: false,
        }))
        break
      case 'only_otp':
        setFields((prevState) => ({
          ...prevState,
          emailField: true,
          passwordField: false,
          otpField: true,
          loginWithOtpTxt: false,
        }))
        break
      case 'password_or_otp':
        setFields((prevState) => ({
          ...prevState,
          emailField: true,
          passwordField: true,
          otpField: true,
          loginWithOtpTxt: true,
        }))
        break
      case 'two_step_auth':
        setFields((prevState) => ({
          ...prevState,
          emailField: true,
          passwordField: true,
          otpField: true,
          loginWithOtpTxt: false,
        }))
        break
      default:
        setFields((prevState) => ({
          ...prevState,
          emailField: true,
          passwordField: true,
          otpField: false,
          loginWithOtpTxt: false,
        }))
        break
    }
  }

  //Forgot pass
  const onChangeForgotPassEmail = (e) => {
    setForgotPasswordEmail(e.target.value)
    setForgotPasswordErr('')
  }

  const onClickForgotSubimitBtn = () => {
    setForgotPasswordErr(
      forgotPasswordEmail === ''
        ? errorsList.email.ERE101
        : forgotPasswordEmail.match(emailReg) !== null
          ? ''
          : errorsList.email.ERE102
    )
    if (forgotPasswordEmail !== '' && forgotPasswordEmail.match(emailReg) !== null) {
      //api call
      let forgotPassReq = {
        email: forgotPasswordEmail,
      }
      if (!captchStates.isCaptchaSelected) {
        setCaptchStates({
          isCaptchaSelected: false,
          captchErrorMsg: 'Please complete the CAPTCHA to proceed',
        })
        return
      }
      setOnClickLoginLoader(true)

      try {
        forgotpassword(forgotPassReq).then((res) => {
          if (res && res.status === true && res.message && res.message !== '') {
            if (loginType == 'two_step_auth') {
              setIsDisplay({ email: false, password: false, loginBtn: false, otp: true })
              setShowOtp(true)
              setType('Signin')
              setExpTime(res?.otp?.otp_expiry_time || 180000)
              setOtpLength(res?.otp?.otp_length)
              setFields({ ...fields, emailField: false, passwordField: false })
            } else {
              // setIsOpen(true);
              setType('ForgotPassMail')
            }
            setForgotPasswordErr('')
          } else {
            setIsOpen(false)
            setForgotPasswordErr(res.message)
          }
          setOnClickLoginLoader(false)
        })
      } catch (error) {
        console.error('Error occurred during forgot password request:', error)
        setOnClickLoginLoader(false)
      }
    } else {
      setIsOpen(false)
    }
  }

  // Login Functinality Starts
  const onChangeLoginEmail = (e) => {
    const email = e.target.value

    let regexEmail = email.replace(alphanumericSpecialChars, '')

    if (!regexEmail) {
      setLogincred({ ...logincred, email })
      setLoginErrors({ ...loginErrors, email: '' })
    }
    if (email.match(emailReg) !== null) {
      setTimeout(() => {
        setIsDisplay({ ...isDisplay, email: false, password: true, otp: false })
        setFields({ ...fields, passwordField: true })
        setForgotPasswordEmail(email)
      }, 500) // Delay to allow user to finish typing
    }
  }

  const onChangeLoginPassword = (e) => {
    let regexPass = e.target.value.replace(alphanumericSpecialChars, '')

    if (!regexPass) {
      setLogincred({ ...logincred, password: e.target.value })
      setLoginErrors({ ...loginErrors, password: '' })
    } else {
      setLoginErrors({ ...loginErrors, password: 'Please Enter Valid Password' })
    }
  }

  //login in button
  const onClickLoginBtn = () => {
    if (loginType == 'only_otp' || (loginType == 'password_or_otp' && !loginWithOtp)) {
      setLoginErrors({
        ...loginErrors,
        email:
          logincred.email === ''
            ? errorsList.email.ERE101
            : logincred.email.match(emailReg) !== null
              ? ''
              : errorsList.email.ERE102,
        password:
          logincred.password === ''
            ? errorsList.password.ERP104
            : logincred.password.match(pwsEx) !== null
              ? ''
              : errorsList.password.ERP105,
      })
    } else {
      setLoginErrors({
        ...loginErrors,
        email:
          logincred.email === ''
            ? errorsList.email.ERE101
            : logincred.email.match(emailReg) !== null
              ? ''
              : errorsList.email.ERE102,
        password:
          logincred.password === ''
            ? errorsList.password.ERP104
            : logincred.password.match(pwsEx) !== null
              ? ''
              : errorsList.password.ERP105,
      })
    }
    setLoginErrMsg('')
    if (
      loginType == 'only_password' ||
      (loginType == 'password_or_otp' && loginWithOtp) ||
      loginType == 'two_step_auth'
    ) {
      onLoginWithPass()
    } else if (loginType == 'only_otp' || (loginType == 'password_or_otp' && !loginWithOtp)) {
      if (logincred.email) onLoginWithOtp()
    } else {
      onLoginWithPass()
    }
  }
  //Login Func Ended

  const onLoginWithPass = () => {
    if (
      logincred.email !== '' &&
      logincred.password !== '' &&
      logincred.password.match(pwsEx) !== null
    ) {
      let encryptedPassword = encryptData(logincred.password)
      let loginReq = {
        email: logincred.email,
        password: encryptedPassword,
        //crypto: true ? true : false,
        // "type": this.state.toggleAgentLogin ? 'agent' : undefined
      }
      setOnClickLoginLoader(true)

      try {
        login(loginReq).then((responseJSON) => {
          if (responseJSON?.isPartialRegister) {
            setLoginErrMsg('User is partially registered')
          }

          let showdisclaimer =
            responseJSON?.type === 'B2E' && responseJSON?.user_type === 'CT' ? true : false

          if (loginType !== 'two_step_auth') {
            if (
              responseJSON.status === true &&
              responseJSON.accessToken !== '' &&
              responseJSON.accessToken !== undefined &&
              responseJSON.accessToken !== null
            ) {
              localStorage.setItem('showdisclaimer', showdisclaimer)
              window.location.href = '/'
            } else {
              if (responseJSON.message == 'Invalid Password') {
                setLoginErrMsg('Incorrect password. Try again')
                setOnClickLoginLoader(false)
              } else {
                setLoginErrMsg(typeof responseJSON.message === 'string' ? responseJSON.message : '')
                setOnClickLoginLoader(false)
              }
            }
          } else {
            if (responseJSON.status === true) {
              if (responseJSON.login_type === 'only_password') {
                localStorage.setItem('showdisclaimer', showdisclaimer)
                window.location.href = '/'
              } else {
                if (responseJSON?.otp?.send_mail) {
                  setIsDisplay({ email: false, password: false, otp: true, loginBtn: false })

                  setExpTime(responseJSON?.otp?.otp_expiry_time || 180000)
                  setShowOtp(true)
                  setOtpLength(responseJSON?.otp?.otp_length)
                  setFields({ ...fields, emailField: false, passwordField: false })
                }
              }
            } else {
              setLoginErrMsg(typeof responseJSON.message === 'string' ? responseJSON.message : '')
              setOnClickLoginLoader(false)
            }
          }
        })
      } catch (error) {
        console.error('Error occurred during login request:', error)
        setOnClickLoginLoader(false)
      }
    }
  }

  const onLoginWithOtp = () => {
    let loginReq = {
      email: logincred.email,
    }

    if (!showOtp) {
      SetIsSendOtp(true)
    }

    try {
      userLogin(loginReq).then((responseJSON) => {
        if (responseJSON.status === true) {
          setOnClickLoginLoader(false)
          if (responseJSON?.send_mail) {
            setExpTime(responseJSON?.otp_expiry_time || 180000)
            setShowOtp(true)
            setIsDisplay({ ...isDisplay, loginBtn: false })
            setOtpLength(responseJSON?.otp_length)
            setFields({ ...fields, emailField: false, otpField: true })
            SetIsSendOtp(false)
          }
        } else {
          setShowOtp(false)
          setLoginErrMsg(typeof responseJSON.msg === 'string' ? responseJSON.msg : '')
          SetIsSendOtp(false)
        }
      })
    } catch (error) {
      console.error('Error occurred during user login request:', error)
      setOnClickLoginLoader(false)
    }
  }

  const handleSubmitOTP = (otp) => {
    setLoginErrors({
      ...loginErrors,
      otp: !otp ? errorsList.OTP.EROTP101 : otp.length != otpLength ? errorsList.OTP.EROTP102 : '',
    })

    if (otp != '' && otp.length == otpLength) {
      setIsOtpValid(true)
      let loginReq = {
        email: logincred.email,
        otp: otp,
        password: '',
        type: loginType == 'two_step_auth' ? 'FORGOTPASSWORD' : '',
      }

      try {
        setOnClickLoginLoader(true)
        userVerify(loginReq).then((responseJSON) => {
          let showdisclaimer =
            responseJSON?.type == 'B2E' && responseJSON?.user_type == 'CT' ? true : false
          setOnClickLoginLoader(false)
          if (responseJSON.status === true) {
            localStorage.setItem('showdisclaimer', showdisclaimer)
            if (responseJSON.url && responseJSON.url !== '') {
              window.location.href = responseJSON.url
            } else {
              window.location.href = '/'
            }

            setIsOtpValid(true)
            setLoginErrors({ ...loginErrors, otp: '' })
          } else {
            setIsOtpValid(false)
            setLoginErrors({
              ...loginErrors,
              otp: responseJSON?.message ? responseJSON?.message : errorsList.OTP.EROTP103,
            })
          }
        })
      } catch (error) {
        console.error('Error occurred during OTP verification:', error)
        setIsOtpValid(false)
        setLoginErrors({
          ...loginErrors,
          otp: 'An error occurred during OTP verification.',
        })
      }
    }
  }

  const onResendOtp = () => {
    let loginReq = {}
    if (loginType == 'two_step_auth') {
      loginReq = {
        email: logincred.email,
        type: 'FORGOTPASSWORD',
      }
    } else {
      loginReq = {
        email: logincred.email,
      }
    }

    try {
      resendOtp(loginReq).then((responseJSON) => {
        if (responseJSON.status === true) {
          console.log('OTP resend successful')
        } else {
          console.log('OTP resend failed')
        }
      })
    } catch (error) {
      console.error('Error occurred while resending OTP:', error)
    }
  }

  const onClickNationalityHandler = (params) => {
    setselectdropdown({ ...selectdropdown, selectedCr: params.value })

    setSelectedNationality(params)
    setCountryCode(params.value)
    setSignupForm({
      ...signupForm,
      nationality: params,
    })
    setSignupFormErr({ ...signupFormErr, nationality: '' })
    if (params.value) {
      const cityListVar = []
      let data = {
        country_name: params.value ? params.value : '',
      }
      getCityByCountry(data).then((res) => {
        if (res && res.data && res.data.length > 0) {
          res.data.map((fact, index) => {
            cityListVar.push({
              value: fact.city_name,
              countryId: index,
              countryName: fact.city_name,
            })
          })
          setCityList([...cityListVar])
          setCityCode('')
          setselectedCity({
            countryId: 0,
            countryName: '',
            value: '',
          })
        }
      })
    }
  }

  const onChangeInputNationality = (params) => {
    setSelectedNationality({ value: params.target.value })
    setCountryCode(params.target.value)
    setSignupForm({ ...signupForm, nationality: params.target.value })
    setselectdropdown({ ...selectdropdown, selectedCr: '' })
  }

  // signup

  const onChangeSignFName = (e) => {
    let regex = e.target.value.replace(alphabetNameChars, '')
    if (!regex) {
      setSignupForm({ ...signupForm, firstName: e.target.value })
      setSignupFormErr({ ...signupFormErr, firstName: '' })
    }
  }

  const onChangeSignLName = (e) => {
    let regex = e.target.value.replace(alphabetNameChars, '')
    if (!regex) {
      setSignupForm({ ...signupForm, lastName: e.target.value })
      setSignupFormErr({ ...signupFormErr, lastName: '' })
    }
  }

  const onChangeSignMobile = (value) => {
    let regex = value.replace(phoneNoReg, '')
    if (!regex) {
      setSignupForm({ ...signupForm, mobileNo: value })
      setSignupFormErr({ ...signupFormErr, mobileNo: '' })
    }
  }

  const onChangeSignCompanyName = (e) => {
    let regex = e.target.value.replace(alphabetNameChars, '')
    if (!regex) {
      setSignupForm({ ...signupForm, companyName: e.target.value })
      setSignupFormErr({ ...signupFormErr, companyName: '' })
    }
  }

  const onChangeRemarks = (e) => {
    let regex = e.target.value.replace(aplhaNumericDash, '')
    if (!regex) {
      setSignupForm({ ...signupForm, remark: e.target.value })
    }
  }

  const onChangeSignEmail = (e) => {
    let regex = e.target.value.replace(alphanumericSpecialChars, '')
    if (!regex) {
      setSignupForm({ ...signupForm, email: e.target.value })
      setSignupFormErr({ ...signupFormErr, email: '' })
    }
  }

  const onSignUpBtn = () => {
    setSignupFormErr({
      ...signupFormErr,
      firstName:
        signupForm.firstName === '' || signupForm.firstName === undefined
          ? errorsList.firstName.ERFN101
          : '',
      lastName:
        signupForm.lastName === '' || signupForm.lastName === undefined
          ? errorsList.lastName.ERLN101
          : '',
      mobileNo:
        signupForm.mobileNo === '' || signupForm.mobileNo === undefined
          ? errorsList.mobileNo.ERMN102
          : signupForm.mobileNo.length > 3
            ? ''
            : errorsList.mobileNo.ERMN101,
      companyName:
        signupForm.companyName === '' || signupForm.companyName === undefined
          ? errorsList.companyName.ERCN101
          : '',
      email:
        signupForm.email === '' || signupForm.email === undefined
          ? errorsList.email.ERE101
          : signupForm.email.match(emailReg) !== null
            ? ''
            : errorsList.email.ERE102,
      nationality: selectdropdown?.selectedCr == '' ? errorsList.nationality.ERNT101 : '',
      orgName: selectdropdown?.selectedOrg == '' ? errorsList.orgName.ERORG101 : '',
      isdCode:
        selectdropdown?.selectedIsd == '' || state?.demoForm?.countryCode == ''
          ? errorsList.isdCode.ERISD101
          : '',
      // pincode: (signupForm.pincode === '' || signupForm.pincode === undefined) ? errorsList.pincode.ERPN101 : '',
    })

    if (
      signupForm.email !== '' &&
      signupForm.firstName !== '' &&
      signupForm.mobileNo !== '' &&
      signupForm.mobileNo.length > 3 &&
      signupForm.lastName !== '' &&
      signupForm.companyName !== '' &&
      selectdropdown?.selectedCr != '' &&
      selectdropdown?.selectedOrg != ''
      // selectdropdown?.selectedIsd != ''
    ) {
      // let isd_code = state.demoForm.countryCode.replace('+', '')
      let isd_code = state.demoForm.countryCode

      let signupReq = {
        site_id: props?.home?.data?.site.id || '',
        first_name: signupForm.firstName,
        last_name: signupForm.lastName,
        company_name: signupForm.companyName,
        mobile_number: signupForm.mobileNo,
        email: signupForm.email,
        country: {
          name: selectedNationality.countryName,
          code: selectedNationality.contry_code,
        },
        // changed the key nationality ->country
        city: {
          name: '',
          code: '',
        },
        address: signupForm.address,
        pincode: signupForm.pincode,
        remark: signupForm.remark,
        company_type: signupForm.orgName,
        isd_code: state?.searchCountryText,
        // type: 'B2B',
      }

      setOnClickLoginLoader(true)

      try {
        contactus(signupReq).then((res) => {
          if (res && res.status && res.message !== '') {
            setSignupFormErr({ email: '' })
            setIsOpen(true)
            setOnClickLoginLoader(false)
            SetIsContactUsConfirm(true)
          } else {
            setSignupFormErr({
              email:
                typeof res.message === 'string'
                  ? res.message
                  : res.message && res.message.length > 0
                    ? res.message[0].msg
                    : 'Something went wrong',
            })
            setOnClickLoginLoader(false)
          }
        })
      } catch (error) {
        console.error('Error occurred during contact us request:', error)
        setOnClickLoginLoader(false)
      }
    }
  }

  const onChangeNewPassword = (e) => {
    if (e.target.value.match(spaceRestrict) && e.target.value.match(passRestrict)) {
      setPasswordObj({ ...passwordObj, newPassword: e.target.value })
      setPasswordObjErr({ ...passwordObjErr, newPassword: '' })
    }
  }

  const onChangeConfirmPassword = (e) => {
    if (e.target.value.match(spaceRestrict) && e.target.value.match(passRestrict)) {
      setPasswordObj({ ...passwordObj, confirmPassword: e.target.value })
      setPasswordObjErr({ ...passwordObjErr, confirmPassword: '' })
    }
  }

  const onClickConfirmbtn = () => {
    setPasswordObjErr({
      ...passwordObjErr,
      newPassword:
        passwordObj.newPassword === ''
          ? errorsList.password.ERP104
          : passwordObj.newPassword.match(pwsEx) !== null
            ? ''
            : errorsList.password.ERP101,
      confirmPassword:
        passwordObj.confirmPassword === ''
          ? errorsList.confirmPassword.ERP102
          : passwordObj.confirmPassword === passwordObj.newPassword
            ? ''
            : errorsList.confirmPassword.ERP103,
    })
    if (
      passwordObj.newPassword !== '' &&
      passwordObj.confirmPassword !== '' &&
      passwordObj.newPassword.match(pwsEx) !== null &&
      passwordObj.confirmPassword === passwordObj.newPassword
    ) {
      let changePassReq = {
        confirm_password: passwordObj.confirmPassword,
        new_password: passwordObj.newPassword,
        resettoken: router.query.resettoken,
      }
      setOnClickLoginLoader(true)

      try {
        changepassword(changePassReq).then((res) => {
          if (res && res.status === true) {
            setPasswordUpdate(true)
            setChangePasswordAPIErr('')
            setOnClickLoginLoader(false)
          } else {
            setChangePasswordAPIErr(res.message)
            setOnClickLoginLoader(false)
          }
        })
      } catch (error) {
        console.error('Error occurred during change password request:', error)
        setOnClickLoginLoader(false)
      }
    }
  }

  const handleTogglePassword = () => {
    setShowPassword(!showPassword)
  }

  const handleViewNewPass = () => {
    setShowNewPassword(!showNewPassword)
  }
  const handleViewConfNewPass = () => {
    setShowNewConfPassword(!showNewConfPassword)
  }

  const onChangeOrg = (value, type) => {
    let values = value.replace(aplhaNumericDash, '').trim()

    setSignupForm({ ...signupForm, orgName: values })
    setSignupFormErr({ ...signupFormErr, orgName: '' })
    type == 'change'
      ? setselectdropdown({ ...selectdropdown, selectedOrg: '' })
      : setselectdropdown({ ...selectdropdown, selectedOrg: values })
    let selectedOrganization = []
    if (values !== '') {
      selectedOrganization = OrganisationList.filter((item) =>
        item.toLowerCase().includes(values.toLowerCase())
      )
    } else {
      selectedOrganization = OrganisationList
    }
  }

  console.log('testmain25==>')

  const handleChangeUsername = () => {
    setType('Signin')
    setIsDisplay({ email: true, password: false, loginBtn: true, otp: false })
    setFields({ ...fields, passwordField: false, emailField: true })
    setLogincred({ email: '', password: '' })
    setLoginErrMsg(' ')
    setLoginErrors({ email: '', password: '', otp: '' })
    setLoginWithOtp(true)
  }

  console.log('testmain02==>')

  const handleSigninUsingPass = () => {
    setIsDisplay({ email: false, password: true, otp: false, loginBtn: true })
    setFields({ ...fields, passwordField: true, emailField: true })
    setLoginErrMsg(' ')
    setLoginErrors({ email: '', password: '', otp: '' })
  }
  const setCaptchDataCallBack = (bool, errorMsg) => {
    setCaptchStates({ isCaptchaSelected: bool })
  }

  const BackToForgotPassword = () => {
    // console.log("testttt");
    cf.redirectTo('/login')
    setType('Forgotpassword')
  }

  const renderlogin = (value) => {
    console.log('DATA==>', props?.home?.data?.data?.header?.logo)

    switch (type) {
      case 'Signin':
        return (
          <>
            <section className={`${styles.login__form} ${styles.singin}`}>
              <div className={styles.login__form_container}>
                <header className={styles.login__form_header}>
                  <div className={styles.login__logo}>
                    <img src={imgLogo} alt="logo" />
                  </div>
                </header>

                <div className={styles.login__form_content}>
                  <div className={styles.login__form_title}>
                    <h2 className={styles.login__heading}>
                      {' '}
                      {isDisplay.otp ? 'Verify OTP' : 'Sign in'}
                    </h2>

                    <p className={styles.login__subheading}>
                      {isDisplay.otp && loginErrMsg == ''
                        ? "We've sent a verification code to your email"
                        : `to ${siteName} Agent Portal`}
                    </p>
                  </div>
                  {fields.emailField && isDisplay.email && (
                    <div className={styles.input_container}>
                      <VmsInputText
                        id="email"
                        type="email"
                        placeholder="Enter email ID"
                        secondPlaceHolder="Email ID"
                        value={logincred.email}
                        onChange={onChangeLoginEmail}
                      />
                      <label htmlFor="email">Email ID</label>

                      {loginErrors.email !== '' && loginErrMsg == '' ? (
                        <div className={styles.errors}>{loginErrors.email}</div>
                      ) : (
                        ''
                      )}
                    </div>
                  )}

                  {!isDisplay.email && (
                    <section className={styles.email_change}>
                      <p className={styles.email_change__address}>{logincred.email}</p>
                      {loginErrMsg !== '' && loginErrMsg == 'User Does not Exists' ? (
                        <div className={styles.errors}>{loginErrMsg}</div>
                      ) : (
                        ''
                      )}
                      {loginErrMsg !== '' &&
                      loginErrMsg == 'Please enter a valid email address.' ? (
                        <div className={styles.errors}>{loginErrMsg}</div>
                      ) : (
                        ''
                      )}
                      <button
                        onClick={() => handleChangeUsername()}
                        className={styles.email_change__button}
                      >
                        Change
                      </button>
                    </section>
                  )}

                  {fields.passwordField && isDisplay.password && (
                    <div className={styles.input_container}>
                      <VmsInputText
                        id="pass"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Enter password"
                        secondPlaceHolder="Password"
                        onChange={onChangeLoginPassword}
                      />
                      <div className={styles.pass_icon}>
                        <img
                          src={showPassword ? 'theme4/view-icon.svg' : 'theme4/hide-icon-01.svg'}
                          alt="pass"
                          onClick={() => {
                            handleTogglePassword()
                          }}
                        />
                      </div>
                      <label htmlFor="password">Password</label>
                    </div>
                  )}

                  {loginErrMsg !== '' ? <div className={styles.errors}>{loginErrMsg}</div> : ''}

                  {fields.passwordField && isDisplay.password && loginErrors.password !== '' ? (
                    <div className={styles.errors}>{loginErrors.password}</div>
                  ) : (
                    ''
                  )}

                  {showOtp && isDisplay.otp && (
                    <>
                      <OTPInput
                        length={otpLength}
                        onSubmit={handleSubmitOTP}
                        exp_time={exp_time}
                        onResendOtp={onResendOtp}
                        css={styles}
                        isOtpValid={isOtpValid}
                        isSingleInput={true}
                        onClickLoginLoader={onClickLoginLoader}
                        otpErr={loginErrors.otp}
                        isSendOtp={isSendOtp}
                      />

                      {/* {loginErrors.otp !== '' ? (
                        <div className={styles.email_error_msgotp}>{loginErrors.otp}</div>
                      ) : (
                        ''
                      )} */}
                    </>
                  )}
                </div>

                {isDisplay.password && (
                  <button
                    type="button"
                    onClick={() => setType('Forgotpassword')}
                    className={styles.login__pfassword}
                  >
                    Forgot Password?
                  </button>
                )}

                <div>{isSendOtp && <div className={styles.loader}></div>}</div>

                <div
                  className={`${isDisplay.loginBtn ? styles.login__actions : ''} ${onClickLoginLoader ? styles.loader_center : ''} ${isDisplay.loginBtn ? styles.forloaderonly : ''}`}
                >
                  {isDisplay.loginBtn && (
                    <div
                      className={`${isDisplay.password ? '' : styles.buttonDisabled} ${styles.buttoncontainer}`}
                    >
                      <VmsButton
                        additionalClassName={`${styles.sign_in_btn} ${onClickLoginLoader && isDisplay.password ? styles.loading : ''}`}
                        // isLoading={isDisplay.password ? onClickLoginLoader:""}
                        onClick={() => {
                          !isDisplay.email || isDisplay.password || isDisplay.otp
                            ? onClickLoginBtn()
                            : ''
                        }}
                      >
                        {!onClickLoginLoader ? (
                          <span>{isDisplay.email ? 'NEXT' : 'SIGN IN'}</span>
                        ) : (
                          <div className={styles.loading_spinner}></div>
                        )}
                      </VmsButton>{' '}
                    </div>
                  )}
                </div>

                {loginType == 'password_or_otp' && isDisplay.password && (
                  <button
                    onClick={() => onClickLoginWithOtp()}
                    type="button"
                    className={styles.login__signin}
                  >
                    SIGN IN USING EMAIL OTP
                  </button>
                )}

                {isDisplay.otp && (
                  <button
                    onClick={() => handleSigninUsingPass()}
                    type="button"
                    className={styles.login__signin}
                  >
                    SIGN IN USING PASSWORD
                  </button>
                )}
                {!isDisplay.email && (
                  <button
                    onClick={() => setType('Signup')}
                    type="button"
                    className={styles.login__signin}
                  >
                    CONTACT SUPPORT
                  </button>
                )}
              </div>
            </section>
          </>
        )
      case 'Signup':
        return (
          <>
            <section className={`${styles.login__form} ${styles.contactus}`}>
              <div className={styles.singup_scroll}>
                <div className={styles.login__form_container}>
                  <header className={styles.login__form_header}>
                    <div className={styles.login__logo}>
                      <img src={imgLogo} alt="logo" />
                    </div>
                  </header>
                  {!isContactUsConfirm && (
                    <div className={styles.login__form_content}>
                      <div className={styles.input_container}>
                        <VmsInputText
                          id="fname"
                          type="text"
                          placeholder="Enter first name"
                          value={signupForm.firstName}
                          onChange={(e) => {
                            onChangeSignFName(e)
                          }}
                        />
                        <label htmlFor="email">First name</label>
                        {signupFormErr.firstName !== '' ? (
                          <div className={styles.errors}>{signupFormErr.firstName}</div>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className={styles.input_container}>
                        <VmsInputText
                          id="lname"
                          type="text"
                          placeholder="Enter last name"
                          value={signupForm.lastName}
                          onChange={onChangeSignLName}
                        />
                        <label htmlFor="lname">Last name</label>
                        {signupFormErr.lastName !== '' ? (
                          <div className={styles.errors}>{signupFormErr.lastName}</div>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className={styles.input_container}>
                        <VmsInputText
                          id="email"
                          type="email"
                          placeholder="Enter email ID"
                          value={signupForm.email}
                          onChange={onChangeSignEmail}
                        />
                        <label htmlFor="email">Email ID</label>
                        {signupFormErr.email !== '' ? (
                          <div className={styles.errors}>{signupFormErr.email}</div>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className={`${styles.input_container} ${styles.singup_flex}`}>
                        <VmsMobileInputText
                          id="phoneNumber"
                          placeholder={'Enter Mobile number'}
                          inputlabel={'Mobile no.*'}
                          rightView={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="6"
                              viewBox="0 0 8 6"
                              fill="none"
                            >
                              <path
                                d="M7.82275 0.694164C7.57475 0.426164 7.17275 0.426164 6.92475 0.694164L4.00475 3.84916L1.08575 0.696164C0.83775 0.428164 0.43475 0.428164 0.18675 0.696164C-0.06225 0.964164 -0.06225 1.39916 0.18675 1.66816L3.55275 5.30516C3.73975 5.50716 4.01175 5.55816 4.24175 5.45616C4.31975 5.42316 4.39375 5.37316 4.45675 5.30516L7.82275 1.66716C8.07075 1.39816 8.07075 0.963164 7.82275 0.694164Z"
                                fill="#4B4B4B"
                              />
                            </svg>
                          }
                          className={styles.contryno}
                          selectedValue={`+91`}
                          selectedIndex={'+91'}
                          defaultValue={'+91'}
                          selectedValueFilterBy={'label'}
                          value={signupForm.mobileNo}
                          mobileNumber={signupForm.mobileNo}
                          onChange={(e) => onChangeSignMobile(e.target.value)}
                          onMobileNumberChange={(e) => onChangeSignMobile(e)}
                          // onCountryChange={(e) => onCountryInputSelectClick({target: {id: 'countryISD', value: e }})}
                          onCountryChange={(val, item) => handleIsdSelect(val, item)}
                          onCountryCodeSelect={(val, item) => handleIsdSelect(val, item)}
                          // onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                          maxLength={'22'}
                        />

                        <label htmlFor="email">Mobile number</label>
                        {signupFormErr.mobileNo !== '' ? (
                          <div className={styles.errors}>{signupFormErr.mobileNo}</div>
                        ) : (
                          ''
                        )}
                      </div>

                      <div className={`${styles.input_container} ${styles.new_country}`}>
                        <CountryDropdownComp
                          theme="theme9"
                          countryFlag={originCountries}
                          searchText={CountryCode}
                          selectCountry={onClickNationalityHandler}
                          selectedCountry={selectedNationality}
                          onChangeInputCountryCode={onChangeInputNationality}
                          placeholder={'Select Country'}
                          isSignUpNationality={true}
                          {...Countrystyles}
                          className={styles.countrycode_singup}
                          isSignup={true}
                        />
                        <label htmlFor="lname">Country</label>

                        {selectdropdown?.selectedCr == '' ? (
                          <div className={styles.errors}>{signupFormErr.nationality}</div>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className={`${styles.input_container} ${styles.input_container_drop}`}>
                        <VmsAutocompleteDropdown
                          id={`title`}
                          additionalClassName="org_drop"
                          autoHighlight
                          items={OrganisationList}
                          onSelect={(val, item) => onChangeOrg(val, item)}
                          value={signupForm?.orgName}
                          isDropdown={true}
                          placeholder="Organisation Type*"
                          label={signupForm?.orgName == '' ? 'Select Organisation Type' : ''}
                        />
                        <label htmlFor="lname">Organisation Type.</label>
                        {selectdropdown?.selectedOrg == '' ? (
                          <div className={styles.errors}>{signupFormErr?.orgName}</div>
                        ) : (
                          ''
                        )}
                      </div>

                      <div className={styles.input_container}>
                        <VmsInputText
                          id="lname"
                          type="text"
                          placeholder="Company Name*"
                          value={signupForm.companyName}
                          onChange={onChangeSignCompanyName}
                        />
                        <label htmlFor="lname">Company Name</label>
                        {signupFormErr.companyName !== '' ? (
                          <div className={styles.errors}>{signupFormErr.companyName}</div>
                        ) : (
                          ''
                        )}
                      </div>

                      <div className={styles.input_container}>
                        <VmsInputText
                          id="remark"
                          type="text"
                          placeholder="Remark"
                          value={signupForm.remark}
                          onChange={onChangeRemarks}
                        />
                        <label htmlFor="email">Remarks</label>
                      </div>
                    </div>
                  )}

                  {isContactUsConfirm && (
                    <div className={styles.confirmation}>
                      <span>
                        <svg
                          width="81"
                          height="81"
                          viewBox="0 0 81 81"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M40.5 0.5C18.42 0.5 0.5 18.42 0.5 40.5C0.5 62.58 18.42 80.5 40.5 80.5C62.58 80.5 80.5 62.58 80.5 40.5C80.5 18.42 62.58 0.5 40.5 0.5ZM32.5 60.5L12.5 40.5L18.14 34.86L32.5 49.18L62.86 18.82L68.5 24.5L32.5 60.5Z"
                            fill="#2DA44E"
                          />
                        </svg>
                      </span>

                      <article className={styles.confirmation__content}>
                        <h2 className={styles.confirmation__title}>Submit confirmation</h2>
                        <p className={styles.confirmation__description}>
                          We've received your submission. Our team will reach out to you soon.
                        </p>
                      </article>
                    </div>
                  )}

                  {/* <div className={styles.login__actions}>
                <VmsButton
                    isLoading={onClickLoginLoader}
                    onClick={() => {
                      !isContactUsConfirm ? onSignUpBtn() : setType('Signin')
                    }}
                  >
                  { !isContactUsConfirm ?  "SUBMIT" : "BACK TO LOGIN"}
                  </VmsButton>
                </div> */}
                  <div className={` ${styles.login__actions}`}>
                    <VmsButton
                      additionalClassName={`${styles.sign_in_btn} ${onClickLoginLoader ? styles.loading : ''}`}
                      // isLoading={isDisplay.password ? onClickLoginLoader:""}
                      onClick={() => {
                        !isContactUsConfirm ? onSignUpBtn() : setType('Signin')
                      }}
                    >
                      {!onClickLoginLoader ? (
                        <span> {!isContactUsConfirm ? 'SUBMIT' : 'BACK TO LOGIN'}</span>
                      ) : (
                        <div className={styles.loading_spinner}></div>
                      )}
                    </VmsButton>{' '}
                  </div>
                  {!isContactUsConfirm && (
                    <button
                      type="button"
                      onClick={() => setType('Signin')}
                      className={styles.login__pfassword}
                    >
                      Back to Login
                    </button>
                  )}
                </div>
              </div>
            </section>
          </>
        )
      case 'Forgotpassword':
        return (
          <>
            <section className={styles.login__form}>
              <div className={styles.login__form_container}>
                <header className={styles.login__form_header}>
                  <div className={styles.login__logo}>
                    <img src={imgLogo} alt="logo" />
                  </div>
                </header>

                <div className={styles.login__form_content}>
                  <div className={styles.login__form_title}>
                    <h2 className={styles.login__heading}>Forgot Password?</h2>
                    <p className={styles.login__subheading}>It's quick and easy to reset!</p>
                  </div>

                  {!isDisplay.email && (
                    <section className={styles.email_change}>
                      <p className={styles.email_change__address}>{logincred.email}</p>
                      <button
                        onClick={() => handleChangeUsername()}
                        className={styles.email_change__button}
                      >
                        Change
                      </button>
                    </section>
                  )}

                  {props.home?.data?.site?.login_captcha_key !== '' &&
                    props.home?.data?.site?.login_captcha_key !== undefined && (
                      <CaptchaComponent
                        // errorMsg={captchStates.captchErrorMsg}
                        setCaptchDataCallback={setCaptchDataCallBack}
                        siteData={props.home?.data}
                        test="test"
                      />
                    )}
                  {forgotPasswordErr !== '' ? (
                    <div className={styles.errors}>{forgotPasswordErr}</div>
                  ) : (
                    ''
                  )}
                  {captchStates.captchErrorMsg !== '' ? (
                    <div className={styles.errors}>{captchStates.captchErrorMsg}</div>
                  ) : (
                    ''
                  )}
                </div>

                <div className={styles.login__actions}>
                  <div
                    className={`${isDisplay.password ? '' : styles.buttonDisabled} ${styles.buttoncontainer}`}
                  >
                    <VmsButton
                      additionalClassName={`${styles.sign_in_btn} ${onClickLoginLoader && isDisplay.password ? styles.loading : ''}`}
                      // isLoading={isDisplay.password ? onClickLoginLoader:""}
                      onClick={() =>
                        isForgotPassSent ? onClickConfirmbtn() : onClickForgotSubimitBtn()
                      }
                    >
                      {!onClickLoginLoader ? (
                        <> {isForgotPassSent ? 'VERIFY' : 'NEXT'}</>
                      ) : (
                        <div className={styles.loading_spinner}></div>
                        // <>
                        // {isForgotPassSent && (
                        //   <div className={styles.loading_spinner}></div>
                        // )}
                        // </>
                      )}
                    </VmsButton>{' '}
                  </div>

                  {/* <VmsButton
                  isLoading={onClickLoginLoader}
                  onClick={()=> isForgotPassSent ? onClickConfirmbtn() : onClickForgotSubimitBtn()  }
                >
                 { isForgotPassSent ? "VERIFY" : "NEXT"  }

                </VmsButton> */}
                </div>
                <button
                  onClick={() => setType('Signup')}
                  type="button"
                  className={styles.login__signin}
                >
                  CONTACT SUPPORT
                </button>
                <button
                  onClick={() => setType('Signin')}
                  type="button"
                  className={styles.login__signin}
                >
                  BACK
                </button>
              </div>
              {isOpen && (
                <ModalPopupComponent
                  modalCss={modalCss}
                  onClosePopup={() => {
                    setIsOpen(false)
                    setType('Signin')
                    setForgotPasswordEmail('')
                  }}
                  isPopup={isOpen}
                  isMobile={false}
                  showCrossButton={true}
                >
                  <div className={styles.modalb_wrap}>
                    <div className={styles.modb_icon}>
                      <img src="/images/email-icon.svg" alt="email" />
                    </div>
                    <div className={styles.modb_title}>
                      <div> We just sent you an email</div>
                      <div>Please follow the instructions in the email to access your account</div>
                    </div>
                    <button
                      className={styles.btn_login}
                      onClick={() => {
                        setIsOpen(false)
                        setType('Signin')
                        setForgotPasswordEmail('')
                      }}
                    >
                      Ok{' '}
                    </button>
                  </div>
                </ModalPopupComponent>
              )}
            </section>
          </>
        )

      case 'ResetPassword':
        return (
          <>
            <section className={styles.login__form}>
              <div className={styles.login__form_container}>
                <header className={styles.login__form_header}>
                  <div className={styles.login__logo}>
                    <img src={imgLogo} alt="logo" />
                  </div>
                </header>

                <div className={`${styles.login__form_content} ${styles.createpassword}`}>
                  <div
                    className={`${styles.login__form_title} ${styles.flexall} ${styles.flexrow}`}
                  >
                    <h2 className={`${styles.login__heading} ${styles.newpasswordtext}`}>
                      Create New Password
                    </h2>

                    <span className={styles.tooltip_newpass_info}>
                      <VmsToolTip title={newPassword}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M10 15C10.2833 15 10.5208 14.9042 10.7125 14.7125C10.9042 14.5208 11 14.2833 11 14V10C11 9.71667 10.9042 9.47917 10.7125 9.2875C10.5208 9.09583 10.2833 9 10 9C9.71667 9 9.47917 9.09583 9.2875 9.2875C9.09583 9.47917 9 9.71667 9 10V14C9 14.2833 9.09583 14.5208 9.2875 14.7125C9.47917 14.9042 9.71667 15 10 15ZM10 7C10.2833 7 10.5208 6.90417 10.7125 6.7125C10.9042 6.52083 11 6.28333 11 6C11 5.71667 10.9042 5.47917 10.7125 5.2875C10.5208 5.09583 
                      10.2833 5 10 5C9.71667 5 9.47917 5.09583 9.2875 5.2875C9.09583 5.47917 9 5.71667 9 6C9 6.28333 9.09583 6.52083 9.2875 6.7125C9.47917 6.90417 9.71667 7 10 7ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 
                      17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
                            fill="#555555"
                          />
                        </svg>
                      </VmsToolTip>
                    </span>
                  </div>

                  <div className={styles.input_container}>
                    <VmsInputText
                      id="pass"
                      type={showNewPassword ? 'text' : 'password'}
                      placeholder="Enter password"
                      secondPlaceHolder="Password"
                      onChange={onChangeNewPassword}
                    />
                    <div className={styles.pass_icon}>
                      <img
                        src={showNewPassword ? 'theme4/view-icon.svg' : 'theme4/hide-icon-01.svg'}
                        alt="pass"
                        onClick={() => {
                          handleViewNewPass()
                        }}
                      />
                    </div>
                    <label htmlFor="email">New Password</label>

                    {passwordObjErr.newPassword !== '' ? (
                      <div className={styles.errors}>{passwordObjErr.newPassword}</div>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className={styles.input_container}>
                    <VmsInputText
                      id="pass"
                      type={showNewConfPassword ? 'text' : 'password'}
                      placeholder="Enter password"
                      secondPlaceHolder="Password"
                      onChange={onChangeConfirmPassword}
                    />
                    <div className={styles.pass_icon}>
                      <img
                        src={
                          showNewConfPassword ? 'theme4/view-icon.svg' : 'theme4/hide-icon-01.svg'
                        }
                        alt="pass"
                        onClick={() => {
                          handleViewConfNewPass()
                        }}
                      />
                    </div>
                    <label htmlFor="email">Confirm New Password</label>

                    {passwordObjErr.confirmPassword !== '' ? (
                      <div className={styles.errors}> {passwordObjErr.confirmPassword}</div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                <div className={styles.login__actions}>
                  <VmsButton isLoading={onClickLoginLoader} onClick={onClickConfirmbtn}>
                    VERIFY
                  </VmsButton>
                </div>

                <button
                  onClick={() => setType('Signup')}
                  type="button"
                  className={styles.login__signin}
                >
                  CONTACT SUPPORT
                </button>
              </div>
              {passwordUpdate && (
                <div className={styles.notification}>
                  <div className={styles.notification__content}>
                    <div className={styles.notification__indicator}></div>
                    <p className={styles.notification__message}>Password updated successfully</p>
                  </div>
                </div>
              )}
            </section>
          </>
        )
      case 'ForgotPassMail':
        return (
          <>
            <section className={styles.login__form}>
              <div className={styles.login__form_container}>
                <header className={styles.login__form_header}>
                  <div className={styles.login__logo}>
                    <img src={imgLogo} alt="logo" />
                  </div>
                </header>
                <div className={styles.password_reset}>
                  <div className={styles.password_reset__container}>
                    <div className={styles.password_reset__header}>
                      <div className={styles.password_reset__icon_wrapper}>
                        <span>
                          <img
                            src="/images/emailIcon.svg"
                            alt="Company logo"
                            className={styles.email__logo_image}
                          />
                        </span>
                      </div>
                      <div className={styles.password_reset__content}>
                        <h1 className={styles.password_reset__title}>
                          Reset password link sent successfully
                        </h1>
                        <p className={styles.password_reset__description}>
                          Please check the email address associated with the email Id{' '}
                          {logincred.email} for instructions to reset your password.
                        </p>
                      </div>
                    </div>
                    <div className={styles.password_reset__email_providers}>
                      <div className={styles.password_reset__provider_icon}>
                        <img
                          src="/images/gmailIcon.svg"
                          alt="Company logo"
                          className={styles.gmail__logo_image}
                        />
                      </div>
                      <div className={styles.password_reset__provider_icon}>
                        <img
                          src="/images/outlookIcon.svg"
                          alt="Company logo"
                          className={styles.outlook__logo_image}
                        />
                      </div>
                      <div className={styles.password_reset__provider_icon}>
                        <img
                          src="/images/yahooIcon.svg"
                          alt="Company logo"
                          className={styles.yahoo__logo_image}
                        />
                      </div>
                    </div>
                    <div className={styles.password_reset__divider}></div>
                    {/* <div className={styles.password_reset__footer}>
                        <span className={styles.password_reset__text}>Did not receive email in</span>
                        <span className={styles.password_reset__link} onClick={BackToForgotPassword()}>Resend email </span>
                        <span className={styles.password_reset__text}>&#123;xx&#125; Seconds</span>
                      </div> */}
                    <button
                      onClick={() => setType('Signin')}
                      type="button"
                      className={styles.login__signin}
                    >
                      BACK
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </>
        )
      case 'resettokenExpiry':
        return (
          <>
            <section className={styles.login__form}>
              <div className={styles.login__form_container}>
                <header className={styles.login__form_header}>
                  <div className={styles.login__logo}>
                    <img src={imgLogo} alt="logo" />
                  </div>
                </header>
                <div className={styles.password_reset}>
                  <div className={styles.password_reset__container}>
                    <div className={styles.password_reset__header}>
                      <div className={styles.password_reset__icon_wrapper}>
                        <span>
                          <img
                            src="/images/emailIcon.svg"
                            alt="Company logo"
                            className={styles.email__logo_image}
                          />
                        </span>
                      </div>
                      <div className={styles.password_reset__content}>
                        <h1 className={styles.password_reset__title}>
                          Reset password link resent successfull
                        </h1>
                        <p className={styles.password_reset__description}>
                          Please check the email address associated with the email Id{' '}
                          {logincred.email} for instructions to reset your password.
                        </p>
                      </div>
                    </div>
                    <div className={styles.password_reset__email_providers}>
                      <div className={styles.password_reset__provider_icon}>
                        <img
                          src="/images/gmailIcon.svg"
                          alt="Company logo"
                          className={styles.email__logo_image}
                        />
                      </div>
                      <div className={styles.password_reset__provider_icon}>
                        <img
                          src="/images/outlookIcon.svg"
                          alt="Company logo"
                          className={styles.email__logo_image}
                        />
                      </div>
                      <div className={styles.password_reset__provider_icon}>
                        <img
                          src="/images/yahooIcon.svg"
                          alt="Company logo"
                          className={styles.email__logo_image}
                        />
                      </div>
                    </div>
                    <div className={styles.password_reset__divider}></div>
                    {/* <div className={styles.password_reset__footer}>
                        <span className={styles.password_reset__text}>Did not receive email in</span>
                        <span className={styles.password_reset__link} onClick={BackToForgotPassword()}>Resend email again </span>
                        <span className={styles.password_reset__text}>&#123;xx&#125; seconds</span>
                      </div> */}
                    <button
                      onClick={() => setType('Signin')}
                      type="button"
                      className={styles.login__signin}
                    >
                      BACK
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </>
        )
      default:
        return null
    }
  }

  const handleIsdSelect = (ele, isd) => {
    setselectdropdown({ ...selectdropdown, selectedIsd: ele ? ele : '' })
    if (ele && isd) {
      var numberPat = isdCodeReg
      if (numberPat.test(isd.label)) {
        setState({
          searchCountryText: isd.label,
          selectedCountry: ele,
          demoForm: { ...state.demoForm, countryCode: isd.label },
          demoErr: { ...state.demoFormErr, countryCode: '' },
        })
      } else {
        setState({
          searchCountryText: isd.label,
          selectedCountry: ele,
          demoForm: { ...state.demoForm, countryCode: isd.label },
          demoFormErr: { ...state.demoFormErr, countryCode: '' },
        })
      }
      signupFormErr.isdCode = ''
    }
  }

  const onClickIsd = () => {
    setState({
      searchCountryText: '',
      selectedCountry: '',
      demoForm: { ...state.demoForm, countryCode: '' },
      demoErr: { ...state.demoFormErr, countryCode: '' },
      demoFormErr: { ...state.demoFormErr, countryCode: '' },
    })
    setselectdropdown({ ...selectdropdown, selectedIsd: '' })
  }

  return (
    <>
      <div className={styles.loginpage}>
        <main className={styles.login}>
          <section className={styles.travel_copy}>
            <h1 className={styles.travel_copy__main_heading}>
              Seamless Travel Management. Maximum Efficiency.
            </h1>
            <div className={styles.travel_copy__features}>
              <article className={styles.travel_copy__feature}>
                <img src="/images/flexiblebooking.svg" />
                <p className={styles.travel_copy__feature_description}>Flexible booking</p>
              </article>
              <article className={styles.travel_copy__feature}>
                <img src="/images/discount.svg" />
                <p className={styles.travel_copy__feature_description}>Incredible deals</p>
              </article>
              <article className={styles.travel_copy__feature}>
                <img src="/images/help.svg" />
                <p className={styles.travel_copy__feature_description}>
                  24/7
                  <br />
                  HELP
                </p>
              </article>
            </div>
          </section>
          {renderlogin()}
        </main>

        <div className={styles.footerFixedcopy}>
          <p>Copyright © 2025. {siteName}. All Rights Reserved.</p>
          <div className={styles.poweredbyvernost}>
            Powered by <img src="/images/vernostlogo.svg" />
          </div>
        </div>
      </div>
    </>
  )
}
